import createIcon from '../../createIcon';

/**
 * @component @name HourglassBottom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMjJMMTcuOTkgMTZMMTQgMTJMMTcuOTkgNy45OUwxOCAySDZWOEwxMCAxMkw2IDE1Ljk5VjIySDE4Wk04IDcuNVY0SDE2VjcuNUwxMiAxMS41TDggNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassBottom = createIcon('HourglassBottom', [
  [
    'path',
    {
      d: 'M18 22L17.99 16L14 12L17.99 7.99L18 2H6V8L10 12L6 15.99V22H18ZM8 7.5V4H16V7.5L12 11.5L8 7.5Z',
      key: 'l610c8',
    },
  ],
]);

export default HourglassBottom;
